import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './login/login.service';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) {  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      return this.checkLogin(state.url);

  }

  checkLogin(url: string): boolean {
    if (localStorage.getItem('token')) { return true; }

    this.loginService.redirectUrl = url;
    this.router.navigate(['/login']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class VendorGuard implements CanActivate {

  constructor(private router: Router, private userService: UserService) {  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.userService.getUserType() === 1) 
      return true;
    else {
      this.router.navigateByUrl('unauthorized');
      return true;
    }
  }

}

@Injectable({
  providedIn: 'root'
})
export class CustomerGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.userService.getUserType() === 2) 
      return true;
    else {
      this.router.navigateByUrl('unauthorized');
      return true;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class SupplierGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.userService.getUserType() === 3) 
      return false;
    else {
      this.router.navigateByUrl('unauthorized');
      return true;
    }
  }
}